import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";
import { LEGAL, CONTACT_EMAIL, UPDATED } from "../data/legal";
import SiteFooter from "../components/SiteFooter";

export default function Legal({ doc }) {
  const navigate = useNavigate();
  const d = LEGAL[doc];
  useEffect(() => { window.scrollTo(0, 0); document.title = `${d.title} · Footie Clash`; }, [d.title]);
  return (
    <div data-testid={`legal-page-${doc}`} className="theme-light bg-app min-h-screen flex flex-col">
      <header className="border-b border-[#E2E8F0] bg-white">
        <div className="max-w-3xl mx-auto px-5 h-14 flex items-center justify-between">
          <button data-testid="legal-back-btn" onClick={() => navigate("/")} className="flex items-center gap-1.5 text-sm font-semibold text-[#334155] hover:text-[#0F172A]">
            <ArrowLeft className="w-4 h-4" /> Back to Footie Clash
          </button>
          <nav className="hidden sm:flex gap-4 text-sm text-[#64748B]">
            <Link to="/privacy" className="hover:text-[#0F172A]">Privacy</Link>
            <Link to="/terms" className="hover:text-[#0F172A]">Terms</Link>
            <Link to="/cookies" className="hover:text-[#0F172A]">Cookies</Link>
          </nav>
        </div>
      </header>
      <main className="flex-1 max-w-3xl w-full mx-auto px-5 py-10">
        <div className="text-[12px] label-eyebrow text-[#059669]">Legal</div>
        <h1 data-testid="legal-title" className="font-display font-extrabold uppercase text-4xl sm:text-5xl text-[#0F172A] mt-1">{d.title}</h1>
        <p className="text-xs text-[#64748B] mt-2">Last updated {UPDATED}</p>
        <p className="text-[#334155] mt-6 leading-relaxed">{d.intro}</p>
        <div className="mt-8 space-y-7">
          {d.sections.map(([h, body], i) => (
            <section key={h}>
              <h2 className="font-semibold text-lg text-[#0F172A]">{i + 1}. {h}</h2>
              <p className="text-[#475569] text-[15px] leading-relaxed mt-1.5">{body}</p>
            </section>
          ))}
        </div>
        <a data-testid="legal-contact-email" href={`mailto:${CONTACT_EMAIL}`} className="mt-10 inline-flex items-center gap-2 rounded-xl border border-[#E2E8F0] bg-white px-4 py-3 text-sm font-semibold text-[#0F172A] hover:border-[#10B981]">
          <Mail className="w-4 h-4 text-[#059669]" /> {CONTACT_EMAIL}
        </a>
      </main>
      <SiteFooter />
    </div>
  );
}
